import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';
import BrindeSaidaForm from './brindeSaidaForm';

import {
    setModoSaida,
    initSaida,
    getSaidas,
    getOpcoes,
    salvarSaida,
    excluirSaida
} from './brindeActions';

const colunas = [
    { field: 'datahora_saida', type: 'date' },
    { field: 'nome_cliente', type: 'text' },
    { field: 'nome_representante', type: 'text' },
    { field: 'quantidade_total', type: 'number' },
    { field: 'nome_usuario_inclusao', type: 'text' }
];

const BrindeSaida = props => {
    const [pesquisa, setPesquisa] = useState('');
    const [sort, setSort] = useState({
        field: 'datahora_saida',
        direction: 'desc'
    });

    useEffect(() => {
        props.getSaidas();
        props.getOpcoes();
    }, []);

    const abrir = (modo, registro) => {
        props.setModoSaida(modo, registro);
        props.initSaida(registro);
    };

    const atualizar = () => {
        props.getSaidas();
        props.getOpcoes();
    };

    const onSort = field => setSort(anterior => ({
        field,
        direction:
            anterior.field === field && anterior.direction === 'asc'
                ? 'desc'
                : 'asc'
    }));

    const termo = pesquisa.trim().toUpperCase();
    const filtradas = (props.saidas || []).filter(item =>
        !termo || [
            item.nome_cliente,
            item.nome_representante,
            item.observacao,
            item.nome_usuario_inclusao,
            ...(item.itens || []).map(brinde => brinde.nome_brinde)
        ].join(' ').toUpperCase().includes(termo)
    );
    const saidas = sortData(filtradas, sort, colunas);
    const podeIncluir = props.getPermissao(
        'brinde_saida',
        ['INCLUSAO']
    );
    const podeAlterar = props.getPermissao(
        'brinde_saida',
        ['ALTERACAO']
    );
    const podeExcluir = props.getPermissao(
        'brinde_saida',
        ['EXCLUSAO']
    );

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modo === 'cadastro' &&
                <BrindeSaidaForm onSubmit={props.salvarSaida} />}

            {props.modo === 'exclusao' &&
                <BrindeSaidaForm
                    excluir
                    onSubmit={props.excluirSaida}
                />}

            {props.modo === 'lista' &&
                <ContentCard>
                    <ContentCardHeader>
                        <Row>
                            <InputPesquisa
                                cols='12 6 3 1'
                                label='Pesquisar'
                                minWidth={344}
                                onChange={setPesquisa}
                            />
                            <div style={{ marginTop: 8 }}>
                                {podeIncluir &&
                                    <button
                                        type='button'
                                        className='btn btn-app bg-success'
                                        onClick={() => abrir('cadastro', {})}
                                    >
                                        <i className='fas fa-plus' />
                                        Adicionar
                                    </button>}
                                <button
                                    type='button'
                                    className='btn btn-app bg-primary'
                                    onClick={atualizar}
                                >
                                    <i className='fas fa-sync-alt' />
                                    Atualizar
                                </button>
                            </div>
                        </Row>
                    </ContentCardHeader>
                    <ContentCardBody>
                        <Table responsive border alturaFixa striped>
                            <THead>
                                <Tr>
                                    <ThSort
                                        field='datahora_saida'
                                        label='Data / Hora'
                                        width={150}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_cliente'
                                        label='Cliente'
                                        width={230}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_representante'
                                        label='Representante'
                                        width={180}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th alignCenter width={330}>
                                        Brindes
                                    </Th>
                                    <ThSort
                                        field='quantidade_total'
                                        label='Quantidade total'
                                        width={140}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_usuario_inclusao'
                                        label='Entregue por'
                                        width={170}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th sticky alignCenter width={80} />
                                </Tr>
                            </THead>
                            <TBody>
                                {saidas.map(item => (
                                    <Tr key={item.id}>
                                        <Td alignCenter>
                                            {getDataHoraFormatada(
                                                item.datahora_saida
                                            )}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_cliente}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_representante}
                                        </Td>
                                        <Td alignCenter>
                                            {(item.itens || []).map(brinde => (
                                                <div key={brinde.id}>
                                                    {brinde.nome_brinde}: {' '}
                                                    {FormatUtils.formatarValorTela(
                                                        brinde.quantidade,
                                                        0
                                                    )}{' '}
                                                    {brinde.sigla_unidade_medida}
                                                </div>
                                            ))}
                                        </Td>
                                        <Td alignCenter>
                                            {FormatUtils.formatarValorTela(
                                                item.quantidade_total,
                                                0
                                            )}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_usuario_inclusao}
                                        </Td>
                                        <Td alignCenter minWidth={90}>
                                            <ButtonTable
                                                type='warning'
                                                width={32}
                                                small
                                                icon='fas fa-pencil-alt'
                                                visible={podeAlterar}
                                                title='Editar'
                                                event={() =>
                                                    abrir('cadastro', item)
                                                }
                                            />
                                            <ButtonTable
                                                type='danger'
                                                width={32}
                                                small
                                                icon='fas fa-trash-alt'
                                                visible={podeExcluir}
                                                title='Excluir'
                                                event={() =>
                                                    abrir('exclusao', item)
                                                }
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCard>}
        </Content>
    );
};

const mapStateToProps = state => ({
    aguardando: state.brinde.aguardando,
    modo: state.brinde.modoSaida,
    saidas: state.brinde.saidas,
    getPermissao: state.auth.getPermissao
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoSaida,
    initSaida,
    getSaidas,
    getOpcoes,
    salvarSaida,
    excluirSaida
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrindeSaida);
